import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { OnboardingStatusResponse, OnboardingStep } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

export function useOnboardingStatus() {
  return useQuery({ queryKey: ['onboarding'], queryFn: () => api.get<OnboardingStatusResponse>('/onboarding') });
}

export function useCompleteOnboardingStep() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (step: OnboardingStep) => api.post<OnboardingStatusResponse>('/onboarding/complete-step', { step }),
    onSuccess: (data) => queryClient.setQueryData(['onboarding'], data),
  });
}
